export enum MessageTypeEnum {
  Call = 'CALL',
  Call_Result = 'CALL_RESULT',
  Call_Error = 'CALL_ERROR',
}
